import { render, staticRenderFns } from "./forgot-password-page.vue?vue&type=template&id=668c4aaa"
import script from "./forgot-password-page.vue?vue&type=script&lang=js"
export * from "./forgot-password-page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../Shield.UI.ProductManagementSystemWebsite/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports